<template>
  <nav
    class="navbar transparent-navbar sticky-top navbar-expand-lg bg-body-tertiary border-bottom border-body"
  >
    <div class="container">
      <a class="navbar-brand" href="/">
        <img
          src="../assets/Salinan LOGO PIU Warna.png"
          width="180"
          height="144"
          class="navbar-logo"
        >
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <div class="row justify-content-end">
          <div class="col-md-12">
            <ul
              class="navbar-nav navbar-auto d-flex justify-content-end align-items-center"
            >
             <!-- <li class="nav-item">
                <router-link class="nav-link" to="/wbs"
                  >Whistle Blowing System</router-link
                >
              </li>-->
              <li class="nav-item">
                <router-link class="nav-link d-flex justify-content-end align-items-center" to="/contact">
                  <!-- <img
                    src="../assets/ButtonDesign/ButtonDesign - Tester.png"
                    style="width: 65%"
                    alt="Kontak Kami"
                  /> -->
                  {{ $t('menuKontak.mainmenu') }}
                </router-link>
              </li>
            </ul>
          </div>
          <hr>
          <div class="col-md-12">
            <div class="row d-flex justify-content-end">
              <!-- <div
                class="col-md-2 d-flex justify-content-start align-items-center"
              >
                <a class="navbar-brand" href="/">
                  <img
                    src="../assets/Salinan LOGO PIU Warna.png"
                    width="120"
                    height="96"
                  />
                </a>
              </div> -->
              <div
                class="col-md-8 me-5 d-flex justify-content-center align-items-center"
              >

              <!-- <div
                class="col-md-8 d-flex justify-content-end align-items-center pe-0"
              > -->
              
                <ul class="navbar-nav navbar-auto">
                  <li class="nav-item dropdown">
                    <router-link
                      class="nav-link dropdown-toggle"
                      to="/media"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      >Profile</router-link
                    >
                    <ul class="dropdown-menu">
                      <li>
                        <router-link class="dropdown-item" to="/sejarah"
                          >{{ $t('menuProfile.submenu1') }}</router-link
                        >
                      </li>
                      <!-- <li>
                                                <router-link class="dropdown-item" to="/visimisi" >Visi Misi</router-link>
                                            </li>
                                            <li>
                                                <router-link class="dropdown-item" to="/nilai" >Nilai-Nilai</router-link>
                                            </li> -->
                      <li>
                        <router-link class="dropdown-item" to="/manajemen"
                          >{{ $t('menuProfile.submenu2') }}</router-link
                        >
                      </li>
                      <li>
                        <router-link class="dropdown-item" to="/struktur"
                          >{{ $t('menuProfile.submenu3') }}</router-link
                        > 
                      </li>
                      <li>
                        <router-link class="dropdown-item" to="/penghargaan"
                          >{{ $t('menuProfile.submenu4') }}</router-link
                        >
                      </li>
                    </ul>
                  </li>
                  <!-- <li class="nav-item">
                                        <router-link class="nav-link" to="/governance" >Tata Kelola</router-link>
                                    </li> -->

                  <li class="nav-item dropdown">
                    <router-link
                      class="nav-link dropdown-toggle"
                      to="/media"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      >{{ $t('menuTatakelola.mainmenu') }}</router-link
                    >
                    <ul class="dropdown-menu">
                      <li>
                        <router-link class="dropdown-item" to="/governance"
                          >{{ $t('menuTatakelola.submenu1') }}</router-link
                        >
                      </li>
                      <li>
                        <router-link class="dropdown-item" to="/audit"
                          >{{ $t('menuTatakelola.submenu2') }}</router-link
                        >
                      </li>
                      <!-- <li>
                                                <router-link class="dropdown-item" to="/complaint" >Customer Complaint</router-link>
                                            </li> -->
                      <!-- <li>
                                                <router-link class="dropdown-item" to="/procurement" >Pengadaan</router-link>
                                            </li> -->
                      <!-- <li>
                                                <router-link class="dropdown-item" to="/wbs" >Whistle Blowing System</router-link>
                                            </li> -->
                    </ul>
                  </li>

                  <!-- <li class="nav-item">
                                        <router-link class="nav-link" to="/pabrik" >Pabrik</router-link>
                                    </li> -->

                  <li class="nav-item dropdown">
                    <router-link
                      class="nav-link dropdown-toggle"
                      to="/media"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      >{{ $t('menuProduklayanan.mainmenu') }}</router-link
                    >
                    <ul class="dropdown-menu" style="width: 200%;">
                      <li>
                        <router-link class="dropdown-item" to="/ggcp"
                          >{{ $t('menuProduklayanan.submenu1') }}</router-link
                        >
                      </li>
                            <li class="dropdown-submenu position-relative">
                            <router-link class="dropdown-item dropdown-toggle" to="/ggcp">
                              {{ $t('menuProduklayanan.submenu2') }}
                            </router-link>
                            <ul class="dropdown-menu submenu w-100 position-absolute start-100 top-0 mt-0">
                              <li>
                                <router-link class="dropdown-item" to="/layanan/investasi-energiutilitas-strategis">
                                  Investasi Energi & Utilitas Strategis
                                </router-link>
                              </li>
                              <li>
                                <router-link class="dropdown-item" to="/layanan/operasi-pemeliharaan">
                                  Operasi & Pemeliharaan
                                </router-link>
                              </li>
                              <li>
                                <router-link class="dropdown-item" to="/layanan/perdagangan-eenrgi-primergas-industri">
                                  Perdagangan Energi Primer
                                </router-link>
                              </li>
                                <li>
                                <router-link class="dropdown-item" to="/layanan/kemitraan-prengembangan-proyek">
                                  Kemitraan Pengembangan Proyek
                                </router-link>
                              </li>
                                 <li>
                                <router-link class="dropdown-item" to="/layanan/portofolio-energi-terbarukan">
                                  Layanan Portofolio Energi Terbarukan
                                </router-link>
                              </li>
                            </ul>
                          </li>
                      <li>
                        <router-link class="dropdown-item" to="/kdm"
                          >{{ $t('menuProduklayanan.submenu3') }}</router-link
                        >
                      </li>
                    </ul>
                  </li>

                  <!-- <li class="nav-item">
                                        <router-link class="nav-link" to="/pengadaan" >Pengadaan</router-link>
                                    </li> -->

                  <!-- <li class="nav-item dropdown">
                                        <router-link class="nav-link dropdown-toggle" to="/media" role="button" data-bs-toggle="dropdown" aria-expanded="false">Publikasi</router-link>
                                        <ul class="dropdown-menu">
                                            <li>
                                                <router-link class="dropdown-item" to="/galeri" >CSR</router-link>
                                            </li>
                                            <li>
                                                <router-link class="dropdown-item" to="/laporan" >Laporan</router-link>
                                            </li>
                                        </ul>
                                    </li> -->

                  <li class="nav-item dropdown">
                    <router-link
                      class="nav-link dropdown-toggle"
                      to="/laporan"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      >{{ $t('menuLaporan.mainmenu') }}</router-link
                    >
                    <ul class="dropdown-menu">
                      <!-- <li>
                                                <router-link class="dropdown-item" to="/laporan" >Laporan Tahunan</router-link>
                                            </li>
                                            <li>
                                                <router-link class="dropdown-item" to="/laporan" >Laporan Keuangan</router-link>
                                            </li>
                                            <li>
                                                <router-link class="dropdown-item" to="/laporan" >Laporan Keberlanjutan</router-link>
                                            </li> -->
                      <li>
                        <router-link class="dropdown-item" to="/laptah"
                          >{{ $t('menuLaporan.submenu1') }}</router-link
                        >
                      </li>
                      <li>
                        <router-link class="dropdown-item" to="/lapkeu"
                          >{{ $t('menuLaporan.submenu2') }}</router-link
                        >
                      </li>
                      <li>
                        <router-link class="dropdown-item" to="/lapkeb"
                          >{{ $t('menuLaporan.submenu3') }}</router-link
                        >
                      </li>
                    </ul>
                  </li>

                  <!-- <li class="nav-item">
                                        <router-link class="nav-link" to="/berita" >Berita</router-link>
                                    </li> -->
                  <li class="nav-item dropdown">
                    <router-link
                      class="nav-link dropdown-toggle"
                      to="/berita"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      >{{ $t('menuBerita.mainmenu') }}</router-link
                    >
                    <ul class="dropdown-menu" style="width: 200%;">
                     <li class="dropdown-submenu position-relative">
                            <router-link class="dropdown-item dropdown-toggle" to="#">
                                {{ $t('menuBerita.submenu1') }}
                            </router-link>
                            <ul class="dropdown-menu submenu w-100 position-absolute start-100 top-0 mt-0">
                              <li>
                                <router-link class="dropdown-item" to="/artikel/2025">
                                  2025
                                </router-link>
                              </li>
                               <li>
                                <router-link class="dropdown-item" to="/artikel/2024">
                                 2024
                                </router-link>
                              </li>
                              <li>
                                <router-link class="dropdown-item" to="/artikel/2023">
                                 2023
                                </router-link>
                              </li>
                                <li>
                                <router-link class="dropdown-item" to="/artikel/2022">
                                 2022
                                </router-link>
                              </li>
                              <li>
                                <router-link class="dropdown-item" to="/artikel/2021">
                                 2021
                                </router-link>
                              </li>
                              <li>
                                    <router-link class="dropdown-item" to="/artikel/2020">
                                 2020
                                </router-link>
                              </li>
                              <li>
                                <router-link class="dropdown-item" to="/artikel/2019">
                                 2019
                                </router-link>
                              </li>
                                
                            </ul>
                          </li>
                            <li class="dropdown-submenu position-relative">
                            <router-link class="dropdown-item dropdown-toggle" to="#">
                               {{ $t('menuBerita.submenu2') }}
                            </router-link>
                            <ul class="dropdown-menu submenu w-100 position-absolute start-100 top-0 mt-0">
                               <li>
                                <router-link class="dropdown-item"  to="/pers/2025">
                                  2025
                                </router-link>
                              </li>
                              <li>
                                <router-link class="dropdown-item"  to="/pers/2024">
                                  2024
                                </router-link>
                              </li>
                              <li>
                                <router-link class="dropdown-item" to="/pers/2023">
                                  2023
                                </router-link>
                              </li>
                              <li>
                                <router-link class="dropdown-item" to="/pers/2022">
                                 2022
                                </router-link>
                              </li>
                                <li>
                                <router-link class="dropdown-item" to="/pers/2021">
                                 2021
                                </router-link>
                              </li>
                              <li>
                                <router-link class="dropdown-item" to="/pers/2020">
                                 2020
                                </router-link>
                              </li>
                              <li>
                                <router-link class="dropdown-item" to="/pers/2019">
                                 2019
                                </router-link>
                              </li>
                              <li>
                                <router-link class="dropdown-item" to="/pers/2016">
                                 2016
                                </router-link>
                              </li>
                                
                            </ul>
                          </li>
                      <li>
                        <router-link class="dropdown-item" to="/buzz"
                          >  {{ $t('menuBerita.submenu3') }}</router-link
                        >
                      </li>
                    </ul>

                    <ul class="dropdown-menu">
                      <li>
                        <router-link class="dropdown-item" to="/artikel"
                          >Artikel</router-link
                        >
                      </li>
                      <li>
                        <router-link class="dropdown-item" to="/pers"
                          >Siaran Pers</router-link
                        >
                      </li>
                      <li>
                        <router-link class="dropdown-item" to="/buzz"
                          >Bulletin BUZZ</router-link
                        >
                      </li>
                    </ul>
                  </li>

                  <!-- <li class="nav-item dropdown">
                                        <router-link class="nav-link dropdown-toggle" to="/pelaporan" role="button" data-bs-toggle="dropdown" aria-expanded="false">Pelaporan</router-link>
                                        <ul class="dropdown-menu">
                                            <li>
                                                <router-link class="dropdown-item" to="/complaint" >Customer Complaint</router-link>
                                            </li>
                                            <li>
                                                <router-link class="dropdown-item" to="/wbs" >Whistle Blowing System (WBS)</router-link>
                                            </li>
                                        </ul>
                                    </li> -->
                  <!--
                  <li class="nav-item">
                    <router-link class="nav-link" to="/pengadaan"
                      >Pengadaan</router-link
                    >
                  </li>-->

                  <!--<li class="nav-item">
                    <router-link class="nav-link" to="/galeri">CSR</router-link>
                  </li>-->
                  <li class="nav-item">
                    <router-link class="nav-link" to="/keberlanjutan">{{ $t('menuKeberlanjutan.mainmenu') }}</router-link>
                  </li>
                </ul>
              </div>
              <div
                class="col-md-3 d-flex justify-content-end align-items-center"
              >
                <SiteSearch placeholder="Search news" />
              </div>
            </div>
            <!-- <hr style="color: white;"> -->
            <!-- <ul class="navbar-nav navbar-auto me-auto d-flex justify-content-center align-items-center">
                            <li class="nav-item dropdown me-2">
                                <router-link class="nav-link dropdown-toggle" to="/media" role="button" data-bs-toggle="dropdown" aria-expanded="false">Profile</router-link>
                                <ul class="dropdown-menu">
                                    <li>
                                        <router-link class="dropdown-item" to="/sejarah" >Sejarah</router-link>
                                    </li>
                                    <li>
                                        <router-link class="dropdown-item" to="/visimisi" >Visi Misi</router-link>
                                    </li>
                                    <li>
                                        <router-link class="dropdown-item" to="/nilai" >Nilai-Nilai</router-link>
                                    </li>
                                    <li>
                                        <router-link class="dropdown-item" to="/manajemen" >Manajemen</router-link>
                                    </li>
                                    <li>
                                        <router-link class="dropdown-item" to="/struktur" >Struktur</router-link>
                                    </li>
                                    <li>
                                        <router-link class="dropdown-item" to="/penghargaan" >Penghargaan</router-link>
                                    </li>
                                </ul>
                            </li>

                            <li class="nav-item dropdown me-2">
                                <router-link class="nav-link dropdown-toggle" to="/media" role="button" data-bs-toggle="dropdown" aria-expanded="false">Tata Kelola</router-link>
                                <ul class="dropdown-menu">
                                    <li>
                                        <router-link class="dropdown-item" to="/governance" >Governance</router-link>
                                    </li>
                                    <li>
                                        <router-link class="dropdown-item" to="/audit" >Audit Charter</router-link>
                                    </li>
                                </ul>
                            </li>

                            <li class="nav-item dropdown me-2">
                                <router-link class="nav-link dropdown-toggle" to="/media" role="button" data-bs-toggle="dropdown" aria-expanded="false">Produk & Layanan</router-link>
                                <ul class="dropdown-menu">
                                    <li>
                                        <router-link class="dropdown-item" to="/ggcp">Produk</router-link>
                                    </li>
                                    <li>
                                        <router-link class="dropdown-item" to="/kdm" >Anak Perusahaan</router-link>
                                    </li>
                                </ul>
                            </li>

                            <li class="nav-item dropdown me-2">
                                <router-link class="nav-link dropdown-toggle" to="/laporan" role="button" data-bs-toggle="dropdown" aria-expanded="false">Laporan</router-link>
                                <ul class="dropdown-menu">
                                    <li>
                                        <router-link class="dropdown-item" to="/laptah">Laporan Tahunan</router-link>
                                    </li>
                                    <li>
                                        <router-link class="dropdown-item" to="/lapkeu">Laporan Keuangan</router-link>
                                    </li>
                                    <li>
                                        <router-link class="dropdown-item" to="/lapkeb">Laporan Keberlanjutan</router-link>
                                    </li>

                                </ul>
                            </li>

                            <li class="nav-item dropdown me-2">
                                <router-link class="nav-link dropdown-toggle" to="/berita" role="button" data-bs-toggle="dropdown" aria-expanded="false">Berita</router-link>
                                <ul class="dropdown-menu">
                                    <li>
                                        <router-link class="dropdown-item" to="/artikel" >Artikel</router-link>
                                    </li>
                                    <li>
                                        <router-link class="dropdown-item" to="/pers" >Siaran Pers</router-link>
                                    </li>
                                    <li>
                                        <router-link class="dropdown-item" to="/buzz" >Bulletin BUZZ</router-link>
                                    </li>
                                </ul>
                            </li>

                            <li class="nav-item me-2">
                                <router-link class="nav-link" to="/pengadaan" >Pengadaan</router-link>
                            </li>

                            <li class="nav-item">
                                <router-link class="nav-link" to="/galeri" >CSR</router-link>
                            </li>

                            <li class="nav-item ms-5 d-flex justify-content-end">
                                <form class="d-flex" role="search" @submit.prevent="search">
                                    <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search" v-model="searchQuery">
                                    <button class="btn btn-outline-light" type="submit">Search</button>
                                </form>
                            </li>
                        </ul> -->
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import SiteSearch from '@/components/SiteSearch.vue'

export default {
  name: "NavBar",
  components: {
    SiteSearch,
  },
};
</script>

<style scoped>
/* .btn, .form-control, .dropdown-menu {
    border-radius: 0px;
} */
.navbar {
  padding-block: 0.65rem;
}

.navbar-brand {
  margin-right: clamp(12px, 2vw, 24px);
  display: flex;
  align-items: center;
}

.navbar-logo {
  width: clamp(132px, 14vw, 180px);
  height: auto;
  max-height: 96px;
}

.navbar-toggler {
  border-color: rgba(8, 78, 139, 0.18);
  border-radius: 20px;
  padding: 0.6rem 0.8rem;
  box-shadow: 0 12px 26px rgba(8, 78, 139, 0.08);
}

.navbar-toggler:focus {
  box-shadow: 0 0 0 0.18rem rgba(8, 78, 139, 0.18);
}

.navbar-collapse {
  margin-top: 1rem;
}

.nav-link {
    color: #084e8b !important;
    font-weight: bold;
}
.nav-link:hover {
  color: #0d6efd !important;
}
.dropdown-item {
  transition: background-color 0.3s ease;
}
.transparent-navbar {
  background-color: transparent;
}
.dropdown-item:hover {
  background-color: #0d6efd;
  color: #fff;
  cursor: pointer;
}
.dropdown-submenu:hover > .submenu {
  display: block;
}
.submenu {
  display: none;
  left: 100%;
  top: 0;
  margin-top: -1px;
}
.dropdown-submenu > .dropdown-toggle::after {

  float: right;
  margin-left: 5px;
  font-size: 0.7em;
}

@media (max-width: 991px) {
  .navbar {
    padding-block: 0.45rem;
  }

  .navbar .container {
    row-gap: 0.75rem;
  }

  .navbar-brand {
    margin-right: 0;
  }

  .navbar-logo {
    width: 136px;
    max-height: 76px;
  }

  .navbar-collapse {
    margin-top: 0.85rem;
    padding: 1rem;
    background: rgba(255, 255, 255, 0.96);
    border: 1px solid rgba(8, 78, 139, 0.08);
    border-radius: 24px;
    box-shadow: 0 22px 42px rgba(8, 78, 139, 0.09);
    backdrop-filter: blur(10px);
  }

  .navbar-collapse .row {
    row-gap: 0.75rem;
  }

  .navbar-nav {
    gap: 0.15rem;
  }

  .nav-link {
    padding: 0.8rem 0 !important;
  }

  .col-md-8.me-5 {
    margin-right: 0 !important;
  }

  .dropdown-menu,
  .submenu {
    position: static !important;
    width: 100% !important;
    box-shadow: none;
  }

  .dropdown-menu {
    border: none;
    background: transparent;
    padding: 0.25rem 0 0.25rem 0.75rem;
  }

  .submenu {
    display: block;
    margin-top: 0.35rem;
    border: none;
    background: transparent;
    padding-left: 0.75rem;
  }
}

@media (max-width: 640px) {
  .navbar-logo {
    width: 112px;
    max-height: 64px;
  }

  .navbar-toggler {
    padding: 0.5rem 0.7rem;
  }

  .navbar-collapse {
    padding: 0.85rem 0.9rem;
  }
}

</style>
